import { OptionsToggle } from './OptionsToggle';
import { Options } from './Options';

declare global {
  interface Navigator {
    keyboard: {
      lock: () => Promise<undefined>;
    };
  }
}

interface OverlayProps {
  hideOptionsToggle?: boolean;
}

export const Overlay = ({ hideOptionsToggle = false }: OverlayProps) => {
  if(hideOptionsToggle) { return null; }
  return (
    <div className='absolute h-full w-full h-max-full w-max-full flex flex-col justify-center z-50'>
      <OptionsToggle />
      <Options />
    </div>
  );
};
